import { render, staticRenderFns } from "./SMSAuthDigitForm.vue?vue&type=template&id=224f03de"
import script from "./SMSAuthDigitForm.vue?vue&type=script&lang=js"
export * from "./SMSAuthDigitForm.vue?vue&type=script&lang=js"
import style0 from "./SMSAuthDigitForm.vue?vue&type=style&index=0&id=224f03de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports